<template>
	<v-form ref="form" v-model="isFormValid" lazy-validation>
		<modal
			:exibir="exibir"
			:titulo="tituloModal"
			:max-width="modalOptions.largura"
			:is-confirmar-desabilitado="!isFormValid"
			@close="fecharModal"
			:custom-actions="false"
			:acao-cancelar="fecharModal"
			:acao-confirmar="confirmar"
			nome-botao-confirmar="Salvar"
			:is-confirmar-visivel="isConfirmarVisivel()"
		>
			<template #body>
				<v-row class="mt-1 mb-2">
					<v-col cols="4">
						<label-personalizado nome-campo="Responsável" class="mb-2"></label-personalizado>
						<span>{{ ocorrenciaInfo.autor }}</span>
					</v-col>
					<v-col cols="4">
						<label-personalizado nome-campo="Última Atualização" class="mb-2"></label-personalizado>
						<span>{{
							ocorrenciaInfo.dataAlteracao
								? ocorrenciaInfo.dataAlteracao
								: ocorrenciaInfo.dataCadastro | formatDataHourMinuteFilter
						}}</span>
					</v-col>
					<v-col cols="4">
						<label-personalizado nome-campo="Atividade" class="mb-2"></label-personalizado>
						<span>{{ ocorrenciaInfo.atividade }}</span>
					</v-col>
				</v-row>
				<v-row class="mt-1 mb-2">
					<v-col cols="12">
						<label-personalizado nome-campo="Descrição" class="mb-2"></label-personalizado>
						<v-textarea
							readonly
							disabled
							ref="descricao"
							:value="ocorrenciaInfo.descricao"
							:rows="4"
							counter="4000"
							class="ma-0 py-0"
							@input="corrigirTexto"
						></v-textarea>
					</v-col>
				</v-row>
				<v-row class="mt-1 mb-2">
					<v-col cols="12">
						<label-personalizado
							nome-campo="Resposta"
							obrigatorio-por-padrao
							class="mb-2"
						></label-personalizado>
						<v-textarea
							ref="resposta"
							v-model="resposta"
							placeholder="Informe a resposta da ocorrência"
							:rules="regras"
							rows="4"
							counter="4000"
							class="ma-0 py-0"
							@input="corrigirTexto"
						></v-textarea>
					</v-col>
				</v-row>
			</template>
		</modal>
	</v-form>
</template>

<script>
import Modal from '@/views/components/Modal.vue'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'

export default {
	name: 'modal-resposta-ocorrencia',
	components: { LabelPersonalizado, Modal },
	mixins: [validacaoFormulario],
	props: {
		exibir: {
			type: Boolean,
		},
		tituloModal: {
			type: String,
			required: true,
		},
		ocorrenciaInfo: {
			type: Object,
			required: true,
		},
	},
	emits: ['fechar-modal'],
	data() {
		return {
			isFormValid: false,
			modalOptions: {
				largura: '1076',
				altura: '1600',
			},
			resposta: '',
			regras: [
				(value) => this.regraObrigatoriedade(value, 'A resposta é obrigatória.'),
				(value) =>
					this.regraDeTamanhoMaximoString(
						value,
						4000,
						'O campo de resposta deve ser igual ou menor que 4000 caracteres!',
					),
			],
		}
	},
	beforeDestroy() {
		this.limparCampo()
	},
	methods: {
		fecharModal() {
			this.$emit('fechar-modal')
		},
		async confirmar() {
			if (this.$refs.form.validate()) {
				await this.$emit('confirmar', {
					idOcorrencia: this.ocorrenciaInfo.id,
					resposta: this.resposta,
				})
			}
		},
		corrigirTexto() {
			if (this.resposta) {
				this.resposta = this.resposta.trim()
			}
		},
		isConfirmarVisivel() {
			return this.resposta && this.isFormValid
		},
		limparCampo() {
			this.resposta = ''
		},
	},
}
</script>

<style lang="stylus" scoped>
.v-dialog
	.texto-titulo
		color #404040
		width 98%
		text-align center
		margin-left 18px
		margin-right 17px
		font-weight 700
		font-size 22px
		line-height 26px

	.close-modal-mobile
		position absolute !important
		right 20px !important

	.mensagem-modal
		display grid !important

	.v-card__title
		word-break break-word

	.texto-corpo
		color #4B4B4B
		font-size 18px
		font-weight 400
		text-align center
		font-style normal
		line-height 25px

	.texto-confirmacao
		color #726f6f
		font-size 18px
		font-weight 400
		text-align center
		font-style normal
		line-height 25px
</style>
